import axios from "axios";
import {
  browserName,
  osName,
  deviceType,
} from "react-device-detect";

let ipAddress;
const getData = async () => {
  const res = await axios.get("https://api.ipify.org/?format=json");
  ipAddress = res?.data?.ip
  console.log(res?.data?.ip)
};

getData()

export const Axios = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

Axios.interceptors.request.use((config) => {

  const token = localStorage.getItem("token");
  config.headers["X-Api-Key"] = process.env.REACT_APP_X_API_KEY;
  config.headers.ipAddress = ipAddress
  config.headers.browser = browserName
  config.headers.os = osName
  config.headers.device = deviceType

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

Axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (401 === error?.response?.status) {
      window.location = "/";
      localStorage.clear()
    } else if (
      "Request failed with status code 500" === error.message ||
      error?.response?.status >= 500
    ) {
      return Promise.reject({
        ...error,
        message: "It's not you, it's us. Try again later.",
      });
    } else {
      return Promise.reject(error);
    }
  }
);
